const appEnv = (process.env.APP_ENV || 'prod')
const lkURL = (process.env.LK_URL || 'https://lk.bimlib.pro')
const authURL = (process.env.AUTH_URL || 'https://auth.bimlib.pro')
const portalURL = (process.env.PORTAL_URL || 'https://bimlib.pro')

function imgUrl(src) {
  if (!src) return src

  src = src[0] === '/' ? src : '/' + src

  const prefix = '/uploads'
  return src.indexOf(prefix) === 0 ? src : prefix + src
}

export default {
  appEnv,
  lkURL,
  authURL,
  portalURL,
  imgUrl,
}
